import React, { useState, useEffect } from "react";
import Modal from '@mui/material/Modal';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import EditWorkerModal from './edit-worker-modal';
import AddWorkerModal from './add-worker-modal';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import CircularProgress from '@mui/material/CircularProgress';

export default function WorkersList() {

    const [allWorkers, setAllWorkers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [open, setOpen] = React.useState(false);
    const [addWorkerOpen, setAddWorkerOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleAddWorkerOpen = () => setAddWorkerOpen(true);
    const handleAddWorkerClose = () => setAddWorkerOpen(false);
    const api_url = process.env.REACT_APP_API_URL;
    const [editedWorkerId, setEditedWorkerId] = useState("");

    useEffect(() => {
        async function getAllWorkersList() {
          setLoading(true);
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
            body: JSON.stringify({ complex_name: 'Охта' })
          };
          try {
          const workersData = await (await fetch(api_url+"/api/allWorkers", requestOptions)).json();
          // 1. Маппинг данных, теперь с полем is_archived
          const mappedWorkers = workersData.map(({worker_id, full_name, phone_number, rank, complex_name, is_archived}) => ({
            workerId: worker_id, 
            fullName: full_name, 
            phoneNumber: phone_number, 
            rank: rank, 
            complexName: complex_name,
            isArchived: is_archived // <-- Добавляем новое поле
          }));

          // 2. Сортировка массива
          const sortedWorkers = mappedWorkers.sort((a, b) => {
            // Сначала сортируем по статусу: активные (false) идут первыми
            if (a.isArchived !== b.isArchived) {
              return a.isArchived - b.isArchived; // false (0) - true (1) = -1, так что a идет раньше
            }
            // Если статусы одинаковые, сортируем по имени в алфавитном порядке
            return a.fullName.localeCompare(b.fullName);
          });
          
          setAllWorkers(sortedWorkers);
          } finally {
            setLoading(false);
          }
        }
        getAllWorkersList();
  
    }, [open, addWorkerOpen]);

    function showModal(visit_id){
        handleOpen();
        setEditedWorkerId(visit_id);
    }

    function showAddWorkerModal(){
        handleAddWorkerOpen();
    }

    return (
        <div>
            <button className='add-visit-button' onClick={() => showAddWorkerModal()}>
                <a>Добавить сотрудника</a>
            </button>
            <TableContainer component={Paper} sx={{ maxHeight: 640 }}>
            <Table stickyHeader aria-label="workers table">
            <TableHead>
                <TableRow>
                    <TableCell>Имя</TableCell>
                    <TableCell>Номер телефона</TableCell>
                    <TableCell>Ранг</TableCell>
                    <TableCell>Комплекс</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {loading ? (
                    <TableRow><TableCell colSpan={6} align="center" sx={{ py: 6 }}><CircularProgress size={28} /></TableCell></TableRow>
                ) : allWorkers.length === 0 ? (
                    <TableRow><TableCell colSpan={6} align="center" sx={{ py: 6, color: 'text.secondary' }}>Нет сотрудников</TableCell></TableRow>
                ) : allWorkers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(({ workerId, fullName, phoneNumber, rank, complexName, isArchived }) => (
                <TableRow key={workerId} hover sx={isArchived ? { opacity: 0.6, backgroundColor: '#fafafa' } : {}}>
                    <TableCell>{fullName}</TableCell>
                    <TableCell>{phoneNumber}</TableCell>
                    <TableCell>{rank}</TableCell>
                    <TableCell>{complexName.join(', ')}</TableCell>
                    <TableCell>
                      {isArchived && <Chip label="В архиве" size="small" />}
                    </TableCell>
                    <TableCell>
                    <Button
                        variant="outlined"
                        onClick={() => showModal(workerId)}>Изменить</Button>
                    </TableCell>
                </TableRow>
                ))}
            </TableBody>
            </Table>
            </TableContainer>
            {!loading && allWorkers.length > 0 && (
            <TablePagination
                component="div"
                count={allWorkers.length}
                page={page}
                onPageChange={(e, p) => setPage(p)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                rowsPerPageOptions={[10, 25, 50, 100]}
                labelRowsPerPage="Строк на странице:"
            />
            )}
            <Modal
            open={open}
            onClose={handleClose}
            >
            <EditWorkerModal editedWorkerId={editedWorkerId} setEditWindowOpen={setOpen}/>
            </Modal>
            <Modal
            open={addWorkerOpen}
            onClose={handleAddWorkerClose}
            >
            <AddWorkerModal setAddWindowOpen={setAddWorkerOpen} />
            </Modal>
        </div>
    )
}

